import React from "react";
import { connect } from "react-redux";
import { Col, Modal, Row } from "react-bootstrap";
import { Field, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ERR, ErrorMessage, LoadingBoton } from "../../_helpers";
import { userService } from "../../_services";
import alertService from "../../_services/cart/alert.service";
import authService from "../../_services/cart/authService";
import vendedorService from "../../_services/cart/vendedor.service";

/** Tiene que coincidir con el tope del backend (VendedorContactoServiceImpl). */
const MAX_CONTACTOS = 20;

/**
 * ABM de los WhatsApp adicionales del vendedor: la gente que trabaja con el y tambien
 * atiende consultas. Se graba la lista completa de una: lo que el vendedor saque de la
 * grilla queda dado de baja del lado del server.
 */
class FormContactosVendedor extends React.Component {

    state = {
        grabando: false,
        cargando: true,
        contactos: [],
    };

    componentDidMount() {
        userService.traerMisContactos().then(
            (data) => {
                this.setState({ contactos: data.contactos ?? [], cargando: false });
            },
            (error) => {
                this.setState({ cargando: false });
                alertService.error(error);
            }
        );
    }

    render() {
        const { cargando, contactos } = this.state;

        let inic = {
            contactos: contactos.map((c) => ({
                id: c.id,
                nombre: c.nombre ?? "",
                whatsapp: c.whatsapp ?? "",
            })),
        };

        const validationSchema = Yup.object().shape({
            contactos: Yup.array().of(
                Yup.object().shape({
                    nombre: Yup.string().required(ERR.REQ).max(100, "Demasiado largo"),
                    whatsapp: Yup.string()
                        .required(ERR.REQ)
                        .matches(/^\+?[0-9]{8,20}$/, "Solo números, sin espacios ni guiones"),
                })
            ),
        });

        return (
            <Modal show={this.props.show} onHide={() => this.props.handleClose()} size="lg" backdrop="static">
                <Modal.Header className="bg-iot text-dark" closeButton>
                    <Modal.Title>Contactos de WhatsApp</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="small">
                        Sumá a las personas que trabajan con vos y también atienden consultas.
                        Cuando alguien toque <b>Consulta</b> en una de tus publicaciones va a poder
                        elegir a quién escribirle. Tu número principal se muestra siempre primero y
                        se cambia desde tus datos personales.
                    </p>

                    {cargando ? (
                        <p className="small">
                            <FontAwesomeIcon icon="fa-solid fa-spinner" spin /> Cargando contactos...
                        </p>
                    ) : (
                        <Formik
                            enableReinitialize={true}
                            initialValues={inic}
                            validationSchema={validationSchema}
                            onSubmit={(values) => {
                                this.setState({ grabando: true });

                                userService.guardarMisContactos(values.contactos).then(
                                    (data) => {
                                        this.setState({ grabando: false, contactos: data.contactos ?? [] });

                                        // El modal publico cachea los contactos por vendedor: si no se
                                        // limpia, el vendedor no ve su propio cambio hasta recargar.
                                        vendedorService.limpiarCacheContactos(authService.getLoggedUserDetail()?.id);

                                        alertService.msg("Contactos actualizados exitosamente.");
                                        this.props.handleClose();
                                    },
                                    (error) => {
                                        this.setState({ grabando: false });
                                        alertService.error(error);
                                    }
                                );
                            }}
                        >
                            {({ values }) => (
                                <Form>
                                    <FieldArray name="contactos">
                                        {({ push, remove }) => (
                                            <>
                                                {values.contactos.length === 0 && (
                                                    <p className="small">Todavía no cargaste contactos.</p>
                                                )}

                                                {values.contactos.map((contacto, index) => (
                                                    <Row key={index} className="align-items-start mb-2">
                                                        <Col sm={5}>
                                                            <label htmlFor={`contactos.${index}.nombre`}>Nombre</label>
                                                            <Field
                                                                name={`contactos.${index}.nombre`}
                                                                className="input--outline w-100"
                                                                type="text"
                                                                placeholder="Ej: Martín (repuestos motor)"
                                                            />
                                                            <ErrorMessage name={`contactos.${index}.nombre`} />
                                                        </Col>
                                                        <Col sm={5}>
                                                            <label htmlFor={`contactos.${index}.whatsapp`}>WhatsApp</label>
                                                            <Field
                                                                name={`contactos.${index}.whatsapp`}
                                                                className="input--outline w-100"
                                                                type="text"
                                                                placeholder="Ej: 1155551234"
                                                            />
                                                            <ErrorMessage name={`contactos.${index}.whatsapp`} />
                                                        </Col>
                                                        <Col sm={2} className="d-flex align-items-end">
                                                            <button
                                                                className="button w-100"
                                                                data-type="accent"
                                                                type="button"
                                                                title="Quitar contacto"
                                                                onClick={() => remove(index)}
                                                            >
                                                                <FontAwesomeIcon icon="fa-solid fa-trash" />
                                                            </button>
                                                        </Col>
                                                    </Row>
                                                ))}

                                                {values.contactos.length < MAX_CONTACTOS && (
                                                    <button
                                                        className="button mt-2"
                                                        data-type="complementary"
                                                        type="button"
                                                        onClick={() => push({ nombre: "", whatsapp: "" })}
                                                    >
                                                        <FontAwesomeIcon icon="fa-solid fa-plus" /> Agregar contacto
                                                    </button>
                                                )}
                                            </>
                                        )}
                                    </FieldArray>

                                    <div className="justify-content-center mt-4 p-3 row border-top bg-light">
                                        <button
                                            className="button"
                                            type="submit"
                                            data-type="primary"
                                            disabled={this.state.grabando}
                                        >
                                            Grabar <LoadingBoton grabando={this.state.grabando} />
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

function mapState(state) {
    return {};
}

const actionCreators = {};

const connectedFormContactosVendedor = connect(mapState, actionCreators)(FormContactosVendedor);
export { connectedFormContactosVendedor as FormContactosVendedor };
